import objectAssign from 'object-assign';
import { produce } from 'immer';
import initialState from './initialState';
import * as types from '../constants/actionTypes';

const userProfileReducer = (state = initialState.userProfile, action) =>
    produce(state, draft => {
        switch (action.type) {
            case types.LOAD_USER_PROFILE_DATA_SUCCESS:
              return objectAssign({}, action.userProfileData);
            case types.LOAD_USER_PROFILE_DATA_ERROR:
              return state;
            case types.APPLICATION_LANGUAGE_CHANGE:
                draft.settings.workingLanguage = action.language;
              break;
            case types.UNIT_SYSTEM_LANGUAGE_CHANGE:
                draft.settings.units = action.unitSystem;
              break;
            case types.Calculation.FILTERS_SAVE_SUCCESS:{
              if (action.calculationType == null) {
                  draft.settings.filterSettings.defaultCalculationFilterSettings = action.calculationFilters;
              } else {
                  let temp = (state.settings.filterSettings.calculationTypeFilterSettings || []).filter(x => x.calculationType !== action.calculationType);
                  draft.settings.filterSettings.calculationTypeFilterSettings = [...temp, { calculationType: action.calculationType, calculationFilterSettingsData: action.calculationFilters }];
              }
            }
            break;
            case types.Calculation.FILTERS_RESET_SUCCESS:
              if (action.calculationType == null) {
                  draft.settings.filterSettings.defaultCalculationFilterSettings = null;
              } else {
                  let temp = (state.settings.filterSettings.calculationTypeFilterSettings || []).filter(x => x.calculationType !== action.calculationType);
                  draft.settings.filterSettings.calculationTypeFilterSettings = [...temp];
              }
            break;
            default:
                return state;
        }
    });

export default userProfileReducer;
